<template>
  <div class="hcl-blocks" v-bind="attributesMeta(props.definition.meta)">
    <div class="row" v-for="row in layoutRowsRowIndices" :key="row">
      <div v-for="block in blocksOnRow(row)" :key="block.layout?.id" :class="'col-' + block.layout?.width">
        <hcl-block :definition="blockForId(block.layout?.id)"></hcl-block>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'

import { useMeta } from '@/composables/meta'

import HclBlock from '@/components/Block/Block.vue'

import { DefinitionBlocks } from '@/components/types'

interface Props {
  /**
   * Definition as an JS object.
   */
  definition: DefinitionBlocks
}

const props = withDefaults(defineProps<Props>(), {
  definition: undefined
})

provide('blocksMetaId', props.definition.meta.id)

const { attributesMeta } = useMeta()

const layoutRowsCount = computed(() => {
  const rowsRowArr = props.definition.content.map((block) => block.layout?.row ?? 0)
  return Math.max(...rowsRowArr, 0) + 1
})

const layoutRowsRowIndices = computed(() => {
  return [...Array(layoutRowsCount.value).keys()]
})

const blocksOnRow = (row: number) => {
  return props.definition.content.filter((block) => {
    return block.layout?.row === row
  })
}

const blockForId = (id: number | undefined) => {
  if (id === undefined) return undefined

  const blocks = props.definition.content.filter((block) => {
    return block.layout?.id === id
  })

  return blocks ? blocks[0] : undefined
}
</script>
